export default "__VITE_PUBLIC_ASSET__6553fdbc__"